import { useSelector } from 'react-redux';
import Icon from '../../../Assets/Icon/CustomIcon';
import { useDispatch } from 'react-redux';
import { PermitActions } from '../../../Reducer/PermitReducer';

export default function WriteFAB({ handleWriteClick }) {
  const { navBar } = useSelector((state) => state.systemBar);
  const dispatch = useDispatch();

  return (
    <button
      className="bg-secondary fixed right-5 z-1 flex h-14 w-14 cursor-pointer items-center justify-center overflow-hidden rounded-full border-none shadow-[0_3px_8px_rgba(0,0,0,0.24)] transition-transform active:scale-95"
      style={{ bottom: `${navBar + 20}px` }}
      onClick={() => {
        dispatch(PermitActions.resetPermitForm());
        handleWriteClick();
      }}
    >
      <Icon.Edit className="h-6 w-6 text-white" />
    </button>
  );
}
